import { render, staticRenderFns } from "./etp_events.vue?vue&type=template&id=326710dc&scoped=true"
import script from "./etp_events.vue?vue&type=script&lang=js"
export * from "./etp_events.vue?vue&type=script&lang=js"
import style0 from "./etp_events.vue?vue&type=style&index=0&id=326710dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326710dc",
  null
  
)

export default component.exports